import { useReduxState } from 'hooks';
import { getCustomizedNavTitle } from 'lib/helpers';
import { Page, PageContent, PageHeader, PageNav } from 'components/page';

interface Props {
  activeLink: string;
  children: React.ReactNode;
}

const AnalyticsPage = ({ activeLink, children }: Props) => {
  const { language, messages, serverConfig } = useReduxState();

  return (
    <Page activePathname="/analytics">
      <PageHeader
        icon="chart-line"
        title={getCustomizedNavTitle({
          defaultTitle: messages.commonAnalytics,
          navLinksCustomTexts: serverConfig.navLinksCustomTexts,
          language,
          section: 'analytics'
        })}
      />

      {!serverConfig.platformCompetenciesOnly && (
        <PageNav
          activeLink={activeLink}
          links={[
            {
              href: '/analytics',
              icon: 'chart-bar',
              title: messages.commonOverview
            },
            ...(serverConfig.hideCoursesFromUI
              ? []
              : [
                  {
                    href: '/analytics/courses',
                    icon: 'book' as const,
                    title: messages.commonCourses
                  }
                ]),
            ...(serverConfig.hidePathsFromUI
              ? []
              : [
                  {
                    href: '/analytics/paths',
                    icon: 'tasks' as const,
                    title: messages.paths
                  }
                ]),
            ...(serverConfig.platformCompetenciesOnly
              ? []
              : [
                  {
                    href: '/analytics/completions',
                    icon: 'history' as const,
                    title: messages.profileCompletionHistory
                  },
                  {
                    href: '/analytics/completion-matrix',
                    icon: 'table' as const,
                    title: messages.completionMatrix
                  }
                ])
          ]}
        />
      )}

      <PageContent>{children}</PageContent>
    </Page>
  );
};

export default AnalyticsPage;
